import * as React from "react";

function SvgIcCar(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41 6.615A1 1 0 018.333 6h7.334a1 1 0 01.923.615L18 10H6l1.41-3.385zM4.477 12H20v5H4v-5h.477zM17 19v1.5a1.5 1.5 0 003 0V19a2 2 0 002-2v-5a2 2 0 00-1.83-1.993l-1.734-4.16A3 3 0 0015.666 4H8.334a3 3 0 00-2.769 1.846L3.83 10.007A2 2 0 002 12v5a2 2 0 002 2v1.5a1.5 1.5 0 003 0V19h10zm-9-4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm9.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcCar;
